import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  showPresence = true;
  showPartnership = false; // for future requirement make it true so that partnership link appears
  isBrowser = false;
  isHome = false;
  isMenuOpen = false;
  activeSection: string = '';
  isScrolled = false;
  currentRoute = '';

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute = event.urlAfterRedirects;
      });
  }

  closeMenu() {
    this.isMenuOpen = false;
  }


  getLinkClasses(section: string): string {
    // IMPORTANT: during SSR / hydration phase
    if (!this.isBrowser) {
      // Return a deterministic, neutral class
      return 'text-[#1D4BA6]';
    }

    const isActive = this.activeSection === section;

    if (this.currentRoute === '/' || this.currentRoute === '/home') {
      return isActive
        ? 'text-[#E17A17]' // active color
        : 'text-[#1D4BA6] hover:text-[#E17A17]';
    }

    if (this.currentRoute === '/home-two') {
      if (this.isScrolled) {
        return isActive
          ? 'text-[#E17A17]'
          : 'text-[#1D4BA6] hover:text-[#E17A17]';
      } else {
        return isActive
          ? 'text-[#E17A17]'
          : 'text-white hover:text-[#E17A17]';
      }
    }

    // fallback
    return isActive
      ? 'text-[#E17A17]'
      : 'text-[#1D4BA6] hover:text-[#E17A17]';
  }

  getMobileLinkClasses(section: string): string {
    // During SSR / hydration
    if (!this.isBrowser) {
      return 'text-[#1D4BA6]';
    }

    const isActive = this.activeSection === section;

    return isActive
      ? 'text-[#E17A17]'
      : 'text-[#1D4BA6] hover:text-[#E17A17]';
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.isBrowser) {
      return;
    }

    this.isScrolled = window.scrollY > 50;
    // const sections = ['about', 'sectors', 'deliver', 'why', 'partnership', 'presence', 'contact'];
    const sections = ['about', 'sectors', 'deliver', 'why', 'presence', 'contact'];                     // Removed 'partnership' as per new requirement and commented in HTML
    for (let id of sections) {
      const el = document.getElementById(id);
      if (el) {
        const rect = el.getBoundingClientRect();
        if (rect.top <= 100 && rect.bottom >= 100) {
          this.activeSection = id;
          break;
        }
      }
    }
  }

}
